document.addEventListener('DOMContentLoaded', function () {
	const pqrs_form = document.querySelector('#pqrs')
	if (!pqrs_form) return

	const submitButton = pqrs_form.querySelector('button')

	function convertFiles() {
		return new Promise((resolve, reject) => {
			const fileInput = document.getElementById('fileInput')
			const files = fileInput.files
			const base64Array = []
			let filesProcessed = 0

			if (files.length === 0) {
				resolve(base64Array)
				return
			}

			Array.from(files).forEach(function (file) {
				const reader = new FileReader()
				reader.readAsDataURL(file)

				reader.onload = function () {
					base64Array.push(reader.result)
					filesProcessed++
					if (filesProcessed === files.length) {
						resolve(base64Array)
					}
				}

				reader.onerror = function (error) {
					reject(error)
				}
			})
		})
	}

	pqrs_form.addEventListener('submit', async function (e) {
		e.preventDefault()

		if (!pqrs_form.reportValidity()) return

		submitButton.disabled = true
		submitButton.innerHTML = 'Enviando...'

		let organization = pqrs_form.organization.value
		let clinic_store = pqrs_form.clinic_store.value
		let user_type = pqrs_form.user_type.value
		let name = pqrs_form.first_name.value
		let last_name = pqrs_form.last_name.value
		let email = pqrs_form.email.value
		let phone = pqrs_form.phone.value
		let document_type = pqrs_form.document_type.value
		let document = pqrs_form.document.value
		let requirement_type = pqrs_form.requirement_type.value
		let reason = pqrs_form.reason.value
		let subject = pqrs_form.subject.value
		let description = pqrs_form.description.value

		const fileInput = pqrs_form.fileInput
		let fileData = []

		if (fileInput && fileInput.files.length > 0) {
			try {
				fileData = await convertFiles()
			} catch (error) {
				submitButton.disabled = false
				submitButton.innerHTML = 'Enviar'
				return
			}
		}

		const formData = {
			organization: organization,
			clinic_store: clinic_store,
			user_type: user_type,
			name: name,
			last_name: last_name,
			email: email,
			phone: phone,
			document_type: document_type,
			document: document,
			requirement_type: requirement_type,
			reason: reason,
			subject: subject,
			description: description,
			file: fileData,
		}

		fetch(
			'https://osl.tenebit.co/index.php?entryPoint=IntegracionPqrs&action=registrarPQRS',
			{
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(formData),
				mode: 'no-cors',
			},
		)
			.then(function () {
				pqrs_form.reset()
				Swal.fire({
					title: 'Información enviada',
					icon: 'success',
				})
			})
			.catch(function () {
				Swal.fire({
					title: 'Error al enviar',
					text: 'Por favor intenta de nuevo más tarde.',
					icon: 'error',
				})
			})
			.finally(function () {
				submitButton.disabled = false
				submitButton.innerHTML = 'Enviar'
			})
	})
})
